import { useCallback, useEffect, useRef, useState } from 'react';
import { countNumberOfCards } from 'utils';
import { useEffectOnce } from 'common/hooks';

export const useGetNumberOfCardsInARow = () => {
	const cardsWrapperRef = useRef<HTMLElement>();

	const [numberOfCardsInARow, setNumberOfCardsInARow] = useState<number>(0);

	const updateData = useCallback(() => {
		cardsWrapperRef.current = __IS_SERVER__
			? null
			: (document.querySelector('.catalogue-categories-wrapper') as HTMLElement);
		setNumberOfCardsInARow(countNumberOfCards(cardsWrapperRef.current));
	}, [setNumberOfCardsInARow]);

	useEffect(() => {
		updateData();
	}, [cardsWrapperRef.current?.children, updateData]);

	useEffectOnce(() => {
		updateData();

		if (!__IS_SERVER__) {
			window.addEventListener('resize', updateData);

			return () => {
				window.removeEventListener('resize', updateData);
			};
		}
		return () => {};
	});

	return numberOfCardsInARow;
};
